import Index from './index.vue';

export default (Application) => {
    let vce = Application.proc.make('VueCustomElement')
    let auth = Application.proc.make('Auth')
    vce.createApp({
        name: "technology-admin",
        category: "工具",
        alias: "工艺编辑器后台管理",
        singleton: true,
        showTitle: false,
        before: () => {
            
             return auth.isAdmin()
            
        }
    }, Index)
}